import React from 'react';
import { PlanCard } from '@/components/PlanCard';

/**
 * Grid of selectable recharge plans for a single platform.
 */
export function RechargePlanGrid({ plans, platformKey, unitLabel, selectedPlanId, onSelect }) {
    return (
        <div className="mt-5">
            <div className="flex items-center justify-between mb-3">
                <div className="font-display font-semibold">
                    Choose a {unitLabel || 'recharge'} plan
                </div>
                <div className="text-xs text-muted-foreground">{plans.length} plans available</div>
            </div>
            <div
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
                data-testid="recharge-plans-grid"
            >
                {plans.map((p) => (
                    <PlanCard
                        key={p.id}
                        plan={p}
                        platform={platformKey}
                        unitLabel={unitLabel}
                        selected={selectedPlanId === p.id}
                        onSelect={onSelect}
                    />
                ))}
            </div>
        </div>
    );
}

export default RechargePlanGrid;
